import styled from 'styled-components';

import { H2 } from '~/src/common/components/Typography';

export const HEIGHT = 240;

export const Title = styled(H2)`
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${HEIGHT}px;
  border-radius: ${({ theme }) => theme.layout.borderRadius};
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  a {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    gap: 8px;
    font-size: 18px;

    strong {
      font-size: 22px;
    }
  }
`;
